const ANALYZER_COPY = {
  pageEyebrow: { ja: "MOTION ANALYZER", zh: "MOTION ANALYZER", en: "MOTION ANALYZER" },
  pageTitle: { ja: "剣道動作分析", zh: "剑道动作分析器", en: "Kendo Motion Analyzer" },
  pageLead: {
    ja: "動画をアップロードして、姿勢推定・段階分解・指標表示までを一気に確認できます。",
    zh: "上传练习视频后，可以直接查看姿态关键点、动作阶段、基础指标和建议。",
    en: "Upload a practice video to inspect pose keypoints, motion phases, baseline metrics, and coaching feedback.",
  },
  practiceType: { ja: "動作タイプ", zh: "动作类型", en: "Practice Type" },
  practiceVideo: { ja: "練習動画", zh: "练习视频", en: "Practice Video" },
  startAnalysis: { ja: "分析開始", zh: "开始分析", en: "Start Analysis" },
  submitting: { ja: "分析中...", zh: "上传分析中...", en: "Analyzing..." },
  selectedFile: { ja: "選択済み", zh: "已选择", en: "Selected" },
  jobsTag: { ja: "JOB BOARD", zh: "JOB BOARD", en: "JOB BOARD" },
  recentJobs: { ja: "最近の分析タスク", zh: "最近分析任务", en: "Recent Jobs" },
  refresh: { ja: "更新", zh: "刷新", en: "Refresh" },
  refreshing: { ja: "更新中...", zh: "刷新中...", en: "Refreshing..." },
  loadingJobs: { ja: "タスク一覧を読み込み中...", zh: "正在读取任务列表...", en: "Loading analysis jobs..." },
  emptyJobs: {
    ja: "まだ分析タスクはありません。まずは素振り動画を1本アップロードしてみましょう。",
    zh: "还没有分析任务，先上传一个素振り视频试试。",
    en: "No analysis jobs yet. Upload a suburi video to create the first one.",
  },
  jobId: { ja: "タスクID", zh: "任务编号", en: "Job ID" },
  createdAt: { ja: "作成時間", zh: "创建时间", en: "Created" },
  viewResult: { ja: "結果を見る", zh: "查看结果", en: "View Result" },
  chooseVideoFirst: { ja: "先に動画ファイルを選択してください。", zh: "请先选择一个视频文件。", en: "Please choose a video file first." },
  jobListFailed: { ja: "タスク一覧の読み込みに失敗しました。", zh: "任务列表读取失败。", en: "Failed to load analysis jobs." },
  uploadFailed: { ja: "アップロードに失敗しました。", zh: "上传失败。", en: "Upload failed." },
  backToAnalyzer: { ja: "分析器へ戻る", zh: "返回分析器", en: "Back to Analyzer" },
  refreshResult: { ja: "結果を更新", zh: "刷新结果", en: "Refresh Result" },
  loadingResult: { ja: "読み込み中...", zh: "读取中...", en: "Loading..." },
  loadingDetail: { ja: "分析結果を読み込み中...", zh: "正在读取分析结果...", en: "Loading analysis result..." },
  reportEyebrow: { ja: "PRACTICE REPORT", zh: "PRACTICE REPORT", en: "PRACTICE REPORT" },
  viewAngle: { ja: "視角", zh: "视角", en: "View" },
  duration: { ja: "長さ", zh: "时长", en: "Duration" },
  frames: { ja: "フレーム数", zh: "帧数", en: "Frames" },
  fps: { ja: "FPS", zh: "FPS", en: "FPS" },
  videoTag: { ja: "VIDEO", zh: "VIDEO", en: "VIDEO" },
  sourceVideo: { ja: "元動画", zh: "原始视频", en: "Source Video" },
  noVideo: {
    ja: "このタスクには再生できる動画成果物がまだありません。",
    zh: "当前任务还没有可播放的视频产物。",
    en: "This job does not have a playable video artifact yet.",
  },
  artifactsTag: { ja: "ARTIFACTS", zh: "ARTIFACTS", en: "ARTIFACTS" },
  artifacts: { ja: "分析成果物", zh: "分析产物", en: "Artifacts" },
  keyframesTag: { ja: "KEYFRAMES", zh: "KEYFRAMES", en: "KEYFRAMES" },
  keyframes: { ja: "キーフレーム分析", zh: "关键帧分析", en: "Keyframe Analysis" },
  frameNo: { ja: "フレーム", zh: "帧", en: "Frame" },
  atTime: { ja: "時間", zh: "时间", en: "Time" },
  phasesTag: { ja: "PHASES", zh: "PHASES", en: "PHASES" },
  phases: { ja: "動作段階", zh: "动作阶段", en: "Phases" },
  feedbackTag: { ja: "FEEDBACK", zh: "FEEDBACK", en: "FEEDBACK" },
  feedback: { ja: "アドバイス", zh: "建议", en: "Feedback" },
  metricsTag: { ja: "METRICS", zh: "METRICS", en: "METRICS" },
  metrics: { ja: "主要指標", zh: "关键指标", en: "Metrics" },
  target: { ja: "目標", zh: "目标", en: "Target" },
  jobNotFound: { ja: "分析タスクが見つかりません。", zh: "未找到该分析任务。", en: "Analysis job not found." },
  loadResultFailed: { ja: "分析結果の読み込みに失敗しました。", zh: "读取分析结果失败。", en: "Failed to load analysis result." },

  deleteJob: { ja: "削除", zh: "删除", en: "Delete" },
  deletingJob: { ja: "削除中...", zh: "删除中...", en: "Deleting..." },
  deleteJobConfirm: {
    ja: "この分析記録を削除しますか？関連ファイルも一緒に削除されます。",
    zh: "要删除这条分析记录吗？相关文件也会一起删除。",
    en: "Delete this analysis record and its related files?",
  },
  deleteJobFailed: { ja: "分析記録の削除に失敗しました。", zh: "删除分析记录失败。", en: "Failed to delete the analysis record." },
};

const PRACTICE_TYPE_LABELS = {
  suburi: { ja: "素振り", zh: "素振", en: "Suburi" },
  "shomen-uchi": { ja: "正面打ち", zh: "正面打", en: "Shomen Uchi" },
  "chudan-no-kamae": { ja: "中段構え", zh: "中段构", en: "Chudan-no-Kamae" },
};

const STATUS_LABELS = {
  queued: { ja: "待機中", zh: "排队中", en: "Queued" },
  processing: { ja: "解析中", zh: "分析中", en: "Processing" },
  completed: { ja: "完了", zh: "已完成", en: "Completed" },
  failed: { ja: "失敗", zh: "失败", en: "Failed" },
};

const VIEW_ANGLE_LABELS = {
  "front-45": { ja: "正面45度", zh: "正面45度", en: "Front 45°" },
  front: { ja: "正面", zh: "正面", en: "Front" },
  side: { ja: "側面", zh: "侧面", en: "Side" },
};

const PHASE_LABELS = {
  kamae: { ja: "構え", zh: "构え", en: "Kamae" },
  furikaburi: { ja: "振りかぶり", zh: "振りかぶり", en: "Raise" },
  downswing: { ja: "振り下ろし", zh: "振下", en: "Downswing" },
  impact: { ja: "打突", zh: "打突", en: "Impact" },
  zanshin: { ja: "残心", zh: "残心", en: "Zanshin" },
  "chudan-no-kamae": { ja: "中段構え", zh: "中段构", en: "Chudan-no-Kamae" },
};

const METRIC_LABELS = {
  chudanSimilarity: { ja: "中段構え相似度", zh: "中段构相似度", en: "Chudan Similarity" },
  poseDetectionRate: { ja: "姿勢検出率", zh: "关键点检测覆盖率", en: "Pose Detection Coverage" },
  shoulderTiltDeg: { ja: "肩線の傾き", zh: "双肩倾斜", en: "Shoulder Tilt" },
  leftWristCenterOffset: { ja: "左拳の中心ずれ", zh: "左拳偏离中心", en: "Left Wrist Center Offset" },
  upperBodyLean: { ja: "上体の前傾", zh: "上身前倾", en: "Upper Body Lean" },
  pelvisLateralDrift: { ja: "骨盤横ぶれ", zh: "骨盆横向晃动", en: "Pelvis Lateral Drift" },
  wristCenterDeviation: { ja: "手首中心面偏差", zh: "手腕中心面偏差", en: "Wrist Center Deviation" },
  elbowBodyDistance: { ja: "肘と体幹の距離", zh: "手肘与躯干距离", en: "Elbow to Body Distance" },
  stanceWidthRatio: { ja: "構え幅比", zh: "站位宽度比", en: "Stance Width Ratio" },
  footAlignmentOffset: { ja: "足部対齐偏差", zh: "脚部对齐偏差", en: "Foot Alignment Offset" },
  footForwardAngleDeg: { ja: "足先の前向き角度", zh: "脚尖朝前角度", en: "Foot Forward Angle" },
  leftHeelLiftRatio: { ja: "左かかとの浮き", zh: "左脚跟抬起", en: "Left Heel Lift" },
  headFacingPlaneDeg: { ja: "頭部正対角度", zh: "头部正对角度", en: "Head Facing Plane" },
};

const METRIC_SUMMARIES = {
  chudanSimilarity: {
    ja: "各フレームを中段構えの条件と比較した総合一致度です。足や手が見えない、両手が上がり続ける、両脚が交差し続けるフレームは 0% 扱いになります。",
    zh: "这是每一帧与中段构条件进行比较后的综合相似度。脚或手看不见、双手一直举起、双腿一直交叉的帧会直接按 0% 处理。",
    en: "Overall frame similarity against the chudan-no-kamae criteria. Frames without visible feet or hands, with both hands raised, or with crossed legs are treated as 0%.",
  },
  poseDetectionRate: {
    ja: "姿勢ランドマークを安定して検出できたフレームの割合です。",
    zh: "检测到姿态关键点的帧占比。",
    en: "Percentage of frames where the pose landmarks were detected.",
  },
  shoulderTiltDeg: {
    ja: "左右肩のラインと水平線の角度差から算出します。",
    zh: "根据左右肩连线与水平线的夹角估算。",
    en: "Estimated from the shoulder line angle against the horizontal axis.",
  },
  leftWristCenterOffset: {
    ja: "鼻先と腰中心から作った体の中心線に対する左拳のずれです。",
    zh: "按身体中线的归一化偏移估算。",
    en: "Estimated as the left wrist offset from the body center line.",
  },
  upperBodyLean: {
    ja: "代表キーフレームで鼻先と腰中心の連線から上体の傾きを推定します。",
    zh: "根据代表关键帧里鼻尖与胯中点连线估算上身倾角。",
    en: "Estimated from the representative keyframe using the line connecting the nose and hip center.",
  },
  pelvisLateralDrift: {
    ja: "骨盤中心の左右ぶれ量を肩幅基準で評価します。",
    zh: "按肩宽基准评估骨盆中心左右晃动量。",
    en: "Measures side-to-side pelvis drift relative to shoulder width.",
  },
  wristCenterDeviation: {
    ja: "左右手首が体の中心面からどれだけ離れているかを見ます。",
    zh: "衡量双手腕偏离身体中心面的程度。",
    en: "Measures how far the wrists drift from the body center plane.",
  },
  elbowBodyDistance: {
    ja: "代表キーフレームで左右肘と体幹線の距離を肩幅比で見ます。",
    zh: "根据代表关键帧，按肩宽比衡量手肘到躯干线的距离。",
    en: "Measures elbow-to-torso distance from the representative keyframe.",
  },
  stanceWidthRatio: {
    ja: "代表キーフレームで足幅が肩幅に対して適切かを見ます。",
    zh: "根据代表关键帧，衡量站位宽度是否接近肩宽。",
    en: "Measures stance width against shoulder width from the representative keyframe.",
  },
  footAlignmentOffset: {
    ja: "代表キーフレームで左足先と右かかとの連線がYOZ平面に沿っているかを見ます。",
    zh: "根据代表关键帧，衡量左脚尖到右脚跟连线是否接近 YOZ 面。",
    en: "Measures whether the left-toe-to-right-heel line stays close to the YOZ plane in the representative keyframe.",
  },
  footForwardAngleDeg: {
    ja: "代表キーフレームで左右の足先ベクトルが前方X軸からどれだけずれているかを見ます。",
    zh: "根据代表关键帧，衡量双脚脚尖方向偏离前方 X 轴的程度。",
    en: "Measures how far each foot drifts from the forward X axis in the representative keyframe.",
  },
  leftHeelLiftRatio: {
    ja: "代表キーフレームで左かかとが前足部よりどれだけ浮いているかを見ます。",
    zh: "根据代表关键帧，衡量左脚跟相对前脚掌抬起的程度。",
    en: "Measures left-heel lift above the ball of the foot in the representative keyframe.",
  },
  headFacingPlaneDeg: {
    ja: "代表キーフレームで頭頂と両耳で作る面がYOZ平面にどれだけ近いかを見ます。",
    zh: "根据代表关键帧，衡量头顶与双耳构成的面是否接近 YOZ 平面。",
    en: "Measures whether the head-top and ear plane stays close to the YOZ plane in the representative keyframe.",
  },
};

const FEEDBACK_TITLES = {
  poseDetectionRate: { ja: "検出安定性", zh: "检测稳定性", en: "Detection Stability" },
  shoulderTiltDeg: { ja: "肩線", zh: "肩线", en: "Shoulder Line" },
  leftWristCenterOffset: { ja: "左拳の軌道", zh: "左拳轨迹", en: "Left Wrist Path" },
  upperBodyLean: { ja: "上体姿勢", zh: "上体姿势", en: "Upper Body Posture" },
  pelvisLateralDrift: { ja: "骨盤の安定", zh: "骨盆稳定", en: "Pelvis Stability" },
  wristCenterDeviation: { ja: "手首の中心面", zh: "手腕中心面", en: "Wrist Center Plane" },
  elbowBodyDistance: { ja: "肘の収まり", zh: "手肘贴身", en: "Elbow Position" },
  stanceWidthRatio: { ja: "構え幅", zh: "站位宽度", en: "Stance Width" },
  footAlignmentOffset: { ja: "足部の対齐", zh: "脚部对齐", en: "Foot Alignment" },
  footForwardAngleDeg: { ja: "足先方向", zh: "脚尖方向", en: "Foot Direction" },
  leftHeelLiftRatio: { ja: "左かかと", zh: "左脚跟", en: "Left Heel" },
  headFacingPlaneDeg: { ja: "頭部の向き", zh: "头部朝向", en: "Head Direction" },
};

const FEEDBACK_MESSAGES = {
  poseDetectionRate: {
    ja: "検出率が低いため、全身が映る固定アングルで撮影すると精度が上がります。",
    zh: "检测率偏低，建议用固定机位并保证全身入镜。",
    en: "Detection coverage is low. A fixed angle with the full body visible should improve it.",
  },
  shoulderTiltDeg: {
    ja: "肩線の傾きが大きめです。肩をすくめずに左右の高さをそろえてみてください。",
    zh: "肩线倾斜偏大，建议放松肩膀并尽量保持两肩水平。",
    en: "Shoulder tilt is high. Relax the shoulders and keep both sides level.",
  },
  leftWristCenterOffset: {
    ja: "左拳が中心線から外れています。鼻先から胴体中央に沿ってまっすぐ通す意識が有効です。",
    zh: "左拳偏离中心线，建议让手部沿身体中线通过。",
    en: "The left wrist is drifting away from center. Try to keep it traveling along the body center line.",
  },
  upperBodyLean: {
    ja: "代表キーフレームで上体の前傾が大きめです。直立から軽い前傾に収め、腰の真上に頭を残す意識が有効です。",
    zh: "代表关键帧里上身前倾偏大，建议控制在直立到微微前倾之间。",
    en: "In the representative keyframe, upper body lean is high. Keep it upright or only slightly forward, with the head stacked over the hips.",
  },
  pelvisLateralDrift: {
    ja: "骨盤の左右ぶれが大きめです。中段構えでは骨盤中心を静かに保ってみてください。",
    zh: "骨盆左右晃动偏大。中段构里尽量让骨盆中心保持稳定。",
    en: "Pelvis drift is high. Try to keep the pelvis center quieter in chudan-no-kamae.",
  },
  wristCenterDeviation: {
    ja: "代表キーフレームで手首が中心面から外れています。左右手首を体の正中線近くに保ってみてください。",
    zh: "代表关键帧里手腕偏离中心面。尽量让双手腕靠近身体中线。",
    en: "In the representative keyframe, the wrists drift away from center. Keep both wrists closer to the body center plane.",
  },
  elbowBodyDistance: {
    ja: "代表キーフレームで肘が体から離れています。左右の肘を体幹線へもう少し収めてみてください。",
    zh: "代表关键帧里手肘离身体偏远。尝试让双肘更贴近躯干线。",
    en: "In the representative keyframe, the elbows drift away from the body. Let both elbows settle closer to the torso lines.",
  },
  stanceWidthRatio: {
    ja: "代表キーフレームで構え幅が基準から外れています。肩幅前後を目安に足幅を整えてみてください。",
    zh: "代表关键帧里站位宽度偏离基准。可以先以接近肩宽作为参考。",
    en: "In the representative keyframe, stance width is outside the target band. Try keeping it around one shoulder width.",
  },
  footAlignmentOffset: {
    ja: "代表キーフレームで足部の連線がずれています。左足先と右かかとの向きをもう少し揃えてみてください。",
    zh: "代表关键帧里脚部连线有偏移。尝试把左脚尖与右脚跟的方向再对齐一些。",
    en: "In the representative keyframe, foot alignment is drifting. Try to align the left toe and right heel more cleanly.",
  },
  footForwardAngleDeg: {
    ja: "代表キーフレームで足先が前方からずれています。左右のつま先をX軸方向へ揃える意識が有効です。",
    zh: "代表关键帧里脚尖方向偏离前方。尽量让双脚脚尖朝向 X 轴正方向。",
    en: "In the representative keyframe, the feet turn away from the forward line. Try to keep both toes pointing along the positive X axis.",
  },
  leftHeelLiftRatio: {
    ja: "代表キーフレームで左かかとの浮きが足りません。左前足部で軽く支える感覚を作ってみてください。",
    zh: "代表关键帧里左脚跟抬起不够。尝试让左前脚掌更明确地承担支撑。",
    en: "In the representative keyframe, the rear left heel is not lifting enough. Let the left ball of the foot carry a little more of the support.",
  },
  headFacingPlaneDeg: {
    ja: "代表キーフレームで頭部の面が正面からずれています。頭頂と両耳の面を保ち、相手へ正対してみてください。",
    zh: "代表关键帧里头部平面偏离正面。尽量让头顶与双耳构成的面保持正对对手。",
    en: "In the representative keyframe, the head drifts off line. Keep the plane formed by the head top and ears facing the opponent more squarely.",
  },
};

const ARTIFACT_LABELS = {
  input: { ja: "元動画", zh: "原始视频", en: "Source Video" },
  keypoints: { ja: "キーポイント JSON", zh: "关键点 JSON", en: "Keypoints JSON" },
};

const SEVERITY_LABELS = {
  info: { ja: "参考", zh: "提示", en: "Info" },
  warning: { ja: "注意", zh: "注意", en: "Warning" },
};

function pickLabel(map, lang, fallback = "") {
  return map?.[lang] || map?.ja || map?.zh || map?.en || fallback;
}

function byKey(dictionary, key, lang, fallback = "") {
  return pickLabel(dictionary?.[key], lang, fallback);
}

export function tAnalyzer(key, lang) {
  return pickLabel(ANALYZER_COPY[key], lang, key);
}

export function formatPracticeTypeLabel(value, lang) {
  return byKey(PRACTICE_TYPE_LABELS, value, lang, value || "-");
}

export function formatStatusLabel(value, lang) {
  return byKey(STATUS_LABELS, value, lang, value || "-");
}

export function formatViewAngleLabel(value, lang) {
  return byKey(VIEW_ANGLE_LABELS, value, lang, value || "-");
}

export function formatPhaseLabel(phaseKey, fallbackLabel, lang) {
  return byKey(PHASE_LABELS, phaseKey, lang, fallbackLabel || phaseKey || "-");
}

export function formatMetricLabel(metricKey, fallbackLabel, lang) {
  return byKey(METRIC_LABELS, metricKey, lang, fallbackLabel || metricKey || "-");
}

export function formatMetricSummary(metricKey, fallbackSummary, lang) {
  return byKey(METRIC_SUMMARIES, metricKey, lang, fallbackSummary || "");
}

export function formatFeedbackTitle(feedbackKey, fallbackTitle, lang) {
  return byKey(FEEDBACK_TITLES, feedbackKey, lang, fallbackTitle || feedbackKey || "-");
}

export function formatFeedbackMessage(feedbackKey, fallbackMessage, lang) {
  return byKey(FEEDBACK_MESSAGES, feedbackKey, lang, fallbackMessage || "");
}

export function formatArtifactLabel(artifactKey, fallbackLabel, lang) {
  return byKey(ARTIFACT_LABELS, artifactKey, lang, fallbackLabel || artifactKey || "-");
}

export function formatSeverityLabel(value, lang) {
  return byKey(SEVERITY_LABELS, value, lang, value || "-");
}

export function localeForLanguage(lang) {
  if (lang === "ja") {
    return "ja-JP";
  }

  if (lang === "en") {
    return "en-US";
  }

  return "zh-CN";
}
